import React, { FC } from 'react';

import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

import { AbstractIcon } from '../abstract-icon';

interface Props {
  className?: string;
}

const MoreActionsIcon: FC<Props> = props => <AbstractIcon {...props} icon={faEllipsisV} />;

export { MoreActionsIcon };